import React from "react";
import styles from "./PaymentFailed.module.css";
import Layout from "../components/Layout/Layout";
import { ReactComponent as FaildIcon } from "../assets/icons/Faild.svg"; // ✅ ایمپورت استاندارد بدون نیاز به استایل اضافی


const PaymentFailed: React.FC = () => {
  return (
   
      <div className={styles.container}>
        {/* ✅ بخش بالایی (پس‌زمینه خاکستری و آیکون خطا) */}
        <div className={styles.topSection}>
          <div className={styles.iconWrapper}>
            <FaildIcon /> {/* ✅ بدون کلاس اضافی */}
          </div>
          <h2 className={styles.title}>پرداخت ناموفق!</h2>
          <p className={styles.subtitle}>پرداخت شما با خطا مواجه شده است.<br />لطفا دوباره تلاش کنید.</p>
        </div>

        {/* ✅ اطلاعات پرداخت */}
        <div className={styles.infoBox}>
          <div className={styles.infoRow}>
            <span className={styles.label}>کد پیگیری</span>
            <span className={styles.value}>1140183884703728434</span>
          </div>
          <div className={styles.infoRow}>
            <span className={styles.label}>زمان ثبت درخواست</span>
            <span className={styles.value}>1403/05/12 - 10:21</span>
          </div>
          <div className={styles.infoRow}>
            <span className={styles.label}>مبلغ پرداخت شده</span>
            <span className={styles.value}>310,000 تومان</span>
          </div>
        </div>

         {/* ✅ پیام اطلاع‌رسانی */}
        <div className={styles.infoText}>

          <p>
            اگر هزینه درخواست از شما کسر شده، مبلغ آن حداکثر در ۷۲ ساعت آینده به حساب‌تان باز می‌گردد.
          </p>
        </div>

        {/* ✅ دکمه‌های عملیاتی */}
        <button className={styles.retryButton} onClick={() => window.location.href = "/payment"}>
          تلاش مجدد
        </button>

        <button className={styles.backButton} onClick={() => window.location.href = "/main"}>
          بازگشت به صفحه اصلی
        </button>
      </div>

  );
};

export default PaymentFailed;
